import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Button } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import { LinkOff } from "@material-ui/icons";
// import { createMuiTheme, withStyles, ThemeProvider } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import { unpairScreen  } from "../../../Actions/screensActions";
import { connect } from "react-redux";
import mqttClient from "../../../Utils/mqtt_config";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

function UnpairScreenModal({data, unpairScreen}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const confirmAction = () => {
      unpairScreen(data.screen_name, () => {
        mqttClient.publish(`cmd_${data.screen_name}_${data.user_id}`, JSON.stringify({"message":{"cmd": "unpair"}} ));
        console.log("Confirm Clicked!");
        handleClose();
      });
  }

  return (
    <div>
      <Button type="button" onClick={handleOpen} variant="contained" color="primary">
        <LinkOff/>
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 100,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h2>Are you sure you want to unpair this screen ?</h2>
            <div>
                <Button
                    variant="contained"
                    color="secondary"
                    className={classes.margin}
                    onClick={confirmAction}
                >
                    Confirm
                </Button>

                <Button
                    variant="contained"
                    className={classes.margin}
                    onClick={handleClose}
                >
                    Cancel
                </Button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

export default connect(null,{unpairScreen})(UnpairScreenModal);